module.exports = __webpack_public_path__ + "img/img09.161874e0.svg";